"use client";

import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";

export default function AboutHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-navy">
      {/* Background image */}
      <div className="absolute inset-0">
        <AppImage
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1ea70a199-1772180127562.png"
          alt="Hong Kong Kwun Tong waterfront district commercial buildings at dusk"
          className="w-full h-full object-cover opacity-25" />
        
        <div className="absolute inset-0 bg-gradient-to-b from-navy/80 via-navy/60 to-navy" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-10 text-center py-32">
        <span className="inline-block text-xs font-black text-orange uppercase tracking-widest mb-4">
          關於我們 · About PC CARGO LIMITED
        </span>
        <h1 className="font-heading font-black text-5xl md:text-6xl text-white leading-tight mb-6">
          香港 × 台灣<br />
          <span className="text-orange">電腦零件貿易橋樑</span>
        </h1>
        <p className="text-white/70 text-lg max-w-2xl mx-auto leading-relaxed">
          從觀塘辦公室到全球買家，PC CARGO LIMITED 提供正品保證、專業倉儲及快速物流服務，
          是您信賴的電腦零件批發夥伴。
        </p>

        {/* Quick stats */}
        <div className="flex flex-wrap justify-center gap-6 mt-12">
          {[
          { icon: "BuildingOfficeIcon", label: "觀塘海濱道139號", sub: "香港辦公室" },
          { icon: "GlobeAsiaAustraliaIcon", label: "台灣總公司", sub: "直接對接原廠" },
          { icon: "ShieldCheckIcon", label: "100% 正品保證", sub: "防偽標籤驗證" },
          { icon: "TruckIcon", label: "DHL / FedEx", sub: "全球快遞配送" }].
          map((item) =>
          <div key={item.label} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-5 py-3">
              <Icon name={item.icon as "BuildingOfficeIcon"} size={20} className="text-orange" />
              <div className="text-left">
                <div className="text-white font-bold text-sm">{item.label}</div>
                <div className="text-white/60 text-xs">{item.sub}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}